const menu = [
	// { name: '系统管理', icon: 'system', pid: 0, id: 1, path: '' },
	// { name: '管理员配置', icon: 'link', pid: 1, id: 2, path: '/' },
	{ name: '小组管理', icon: 'group', pid: 0, id: 3, path: '' },
	{ name: '打卡小组', icon: 'link', pid: 3, id: 4, path: '/group' },
	{ name: '申请记录', icon: 'link', pid: 3, id: 5, path: '/applyRecord' },
	{ name: '标签管理', icon: 'link', pid: 3, id: 6, path: '/tag' },
	// { name: '系统学员', icon: 'people', pid: 0, id: 5, path: '' },
	// { name: '学员总览', icon: 'link', pid: 5, id: 6, path: '' },
	{ name: '账号管理', icon: 'audit', pid: 0, id: 7, path: '/user' },
	{ name: '配置中心', icon: 'audit', pid: 0, id: 8, path: '/config' },
	{ name: '用户管理', icon: 'people', pid: 0, id: 9, path: '' },
	{ name: '用户列表', icon: 'people', pid: 9, id: 10, path: '/people/list' },
	{ name: '用户评论', icon: 'comment', pid: 9, id: 11, path: '/people/comment' },

];


export default menu;
